import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { SkillLevelValidationStatus } from "@sol/sdk";
import { Check01 } from "@sol/uikit/core/icons/General/Check01";
import { X01 } from "@sol/uikit/core/icons/General/X01";
import { Tag } from "@sol/uikit/data-display/Tag/Tag";

type Props = {
    level: number;
    status?: SkillLevelValidationStatus;
    className?: string;
    hideIcon?: boolean;
};

const statusInformations = {
    [SkillLevelValidationStatus.VALIDATED]: {
        message: "accessibility.corrections.skillLevels.valid",
        icon: <Check01 size={16} />,
    },
    [SkillLevelValidationStatus.UNVALIDATED]: {
        message: "accessibility.corrections.skillLevels.invalid",
        icon: <X01 size={16} />,
    },
    [SkillLevelValidationStatus.NOT_EVALUATED]: {
        message: "accessibility.corrections.skillLevels.notEvaluated",
        icon: null,
    },
};

const SkillLevelTag = ({ level, status, className, hideIcon }: Props) => {
    const [t] = useTranslation();

    const statusInfos = status && statusInformations[status];

    return (
        <Tag
            className={clsx(
                "text-center [&>span]:block [&>span]:h-full [&>span]:flex-1 [&>span]:truncate [&>span]:overflow-hidden",
                className,
            )}
            color={
                status === SkillLevelValidationStatus.VALIDATED
                    ? "success"
                    : status === SkillLevelValidationStatus.UNVALIDATED
                      ? "error"
                      : "default"
            }
            icon={!hideIcon ? statusInfos?.icon : null}
            title={t(`component.skillLevelChip.level${level}`)}
        >
            <span>{t(`component.skillLevelChip.level${level}`)}</span>
        </Tag>
    );
};

SkillLevelTag.defaultProps = {
    status: SkillLevelValidationStatus.NOT_EVALUATED,
};

export default SkillLevelTag;
